import React from 'react';

const Menu = () => {
    return (
        <></>
    )
}

export default Menu;